export const TEMP_DATASOURCE_ID = "temp-id-0";
export const DATASOURCE_NAME_DEFAULT_PREFIX = "Untitled Datasource ";
export const GOOGLE_SHEET_SPECIFIC_SHEETS_SCOPE =
  "https://www.googleapis.com/auth/drive.file";
